import { Component, Input } from "@angular/core";

@Component({
    selector: 'app-record-type-display',
    template: `
    <div class="reportType-value">
                            {{ (value | number: '1.0-1') || ''}}
                        </div>
                        <div class="reportType-land"
                            *ngIf="prop_type_govt && prop_type_estater && prop_type_govt !== prop_type_estater">
                            <del>{{ prop_type_govt | translate }}</del>
                            <span class="reportType">*{{ prop_type_estater | translate }}</span>
                        </div>
                        <div class="reportType-land"
                            *ngIf="!prop_type_estater || prop_type_govt === prop_type_estater">
                            {{ (prop_type_govt || prop_type_estater) | translate }}
                        </div>
  `,
})
export class RecordTypeDisplayComponent {
    @Input() value: any;
    @Input() prop_type_govt: string = '';
    @Input() prop_type_estater: string = '';
}